import { useContext } from "react";

import { Claims, ClaimsContext } from "../components/ClaimsContext";

export const useClaims = (): [Claims | undefined, boolean] => {
  const { claims, isLoading } = useContext(ClaimsContext);
  return [claims, isLoading];
};
